export default __webpack_public_path__ + "static/media/img-58.c967806d.jpg";